import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { singlePatientProgressNoteByEntityType } from '@mummssoftware/utils/utils';

/**
 * Upsert a PUT/POST progress-note response into the progressNotesGlobal list.
 *
 * Observation save responses return patientprogressnoteentitydto as an array.
 * progressNotesGlobal (from getProgressNotes) stores it keyed by entitytypeshortname
 * (e.g. { OTH: [...] }) via patientProgressNoteByEntityType. PN filters/menus read
 * note.patientprogressnoteentitydto[entityType], so we must normalize before upsert.
 */
export const upsertProgressNoteGlobal = (notes, savedNote) => {
  // Array → keyed entity map (same transform as getProgressNotes list path)
  const normalized = singlePatientProgressNoteByEntityType(savedNote);
  const list = notes ? [...notes] : [];
  const id = String(normalized.id);
  const idx = list.findIndex(n => String(n.id) === id);

  if (idx >= 0) {
    list[idx] = _objectSpread(_objectSpread({}, list[idx]), normalized);
  } else {
    list.unshift(normalized);
  }

  return list;
};